
import { SeoMetricsChart } from "../SeoMetricsChart";
import { SeoResult } from "./types";

interface SeoScoreOverviewProps {
  result: SeoResult;
  getScoreColor: (score: number) => string;
}

export const SeoScoreOverview = ({ result, getScoreColor }: SeoScoreOverviewProps) => {
  return (
    <div className="mb-8 flex flex-col md:flex-row items-center">
      <div className="mb-6 md:mb-0 md:mr-8">
        <div className="relative w-40 h-40">
          <svg viewBox="0 0 120 120" className="w-full h-full transform -rotate-90">
            <circle
              cx="60"
              cy="60"
              r="54"
              fill="none"
              stroke="currentColor"
              className="text-muted"
              strokeWidth="12"
            />
            <circle
              cx="60"
              cy="60"
              r="54"
              fill="none"
              stroke="currentColor"
              className={getScoreColor(result.score)}
              strokeWidth="12"
              strokeDasharray="339.3"
              strokeDashoffset={339.3 - (339.3 * result.score) / 100}
              strokeLinecap="round"
            />
          </svg>
          <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
            <div className="text-center">
              <div className={`text-3xl font-bold ${getScoreColor(result.score)}`}>
                {result.score}
              </div>
              <div className="text-sm text-muted-foreground">SEO Score</div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="flex-grow">
        <h3 className="text-xl font-bold mb-3">SEO Performance Metrics</h3>
        <SeoMetricsChart metrics={result.metrics} />
      </div>
    </div>
  );
};

export default SeoScoreOverview;
